export const decodeHtml = (input) => {
  const div = document.createElement('div');
  div.innerHTML = input;
  return div.childNodes.length === 0 ? '' : div.childNodes[0].nodeValue;
};
